import { Button, Form, Input, message } from 'antd';
import { API, PATH } from 'data';
import Image from 'next/image';
import { useSearchParams } from 'next/navigation';
import { useEffect, useState } from 'react';
import logo from 'assets/images/logo.png';
import { AppStorage, RestAPI, ToEnglish, useAsyncClick } from 'scripts';
import { JWTTokenType } from 'types';
import { __CodeFieldType, __OtpFormCompPropsType } from '../login.type';
import styles from './otpForm.module.scss';

function OtpFormComp({ setPhone, phone }: __OtpFormCompPropsType) {
    const [timeLeft, setTimeLeft] = useState(120);
    const [form] = Form.useForm<__CodeFieldType>();
    const [messageApi, contextHolder] = message.useMessage();
    const params = useSearchParams();

    const finishHandler = async ({ code }: __CodeFieldType) => {
        return new Promise((resolve) => {
            const bodyRequest = { code: ToEnglish(code), phone };

            RestAPI.post<JWTTokenType>(API.middlewares.login, bodyRequest)
                .then((res) => {
                    AppStorage.authToken.set(res.data);
                    window.location.href = params.get('redirect') ?? PATH.panel.index;
                })
                .catch(() => {
                    messageApi.error('خطایی به وجود آمده است. لطفا بعدا تلاش کنید.');
                    resolve(true);
                });
        });
    };
    const verifyCodeHandler = useAsyncClick(finishHandler);

    useEffect(() => {
        if (timeLeft > 0) {
            const interval = setInterval(() => {
                setTimeLeft(timeLeft - 1);
            }, 1000);

            return () => clearInterval(interval);
        }
    }, [timeLeft]);

    return (
        <div className={`${styles['login-content']} flex-column center-content-y flex-1`}>
            {contextHolder}
            <h1 className="text-center t-600 t-l-black1 mb-3 d-pre-md-none">
                تیک <span className="t-primary">سبز</span>
            </h1>
            <div className={`${styles['logo-image']} d-md-none w-100 center-content mb-4`}>
                <Image src={logo} alt="تیک سبز" width={154} height={154} />
            </div>
            <h3 className="t-h3-i t-l-black1 t-400 text-center mb-4">
                لطفا برای ورود، کد تایید ارسال شده را وارد کنید
            </h3>
            <div className={`${styles['edit-phone']} justify-content-between center-content-y mb-3`}>
                <p className="t-400 t-p1 t-l-black1">{phone}</p>
                <p className="t-400 t-p1 t-primary-i pointer" onClick={() => setPhone(null)}>
                    ویرایش شماره تلفن
                </p>
            </div>
            <Form
                className="w-100"
                form={form}
                layout="vertical"
                requiredMark={false}
                onFinish={verifyCodeHandler.onClick}
            >
                <Form.Item
                    className="mb-4-i"
                    name="code"
                    rules={[{ required: true, message: 'لطفا کد پنج رقمی را وارد کنید' }]}
                >
                    <Input.OTP type="number" dir="ltr" length={5} />
                </Form.Item>
                <div className={`${styles['btns']} center-content flex-column w-100`}>
                    <Button loading={verifyCodeHandler.loading} htmlType="submit" className="w-100 mb-2-i">
                        ورود
                    </Button>
                    <Button
                        disabled={timeLeft > 0 ? true : false}
                        onClick={() => setTimeLeft(120)}
                        className="w-100"
                        type="primary"
                    >
                        {timeLeft > 0 ? `${timeLeft} ثانیه تا ارسال مجدد کد` : 'ارسال مجدد کد'}
                    </Button>
                </div>
            </Form>
        </div>
    );
}

export default OtpFormComp;
